"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _savingsCalculator = _interopRequireDefault(require("./savings-calculator"));
var _leadGenFormModal = _interopRequireDefault(require("../lead-gen-form-modal"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _reactIntersectionObserver = require("react-intersection-observer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SavingsCalculator({
  eid,
  modalContent,
  ...savingsCalculatorContent
}) {
  const [modalOpen, setModalOpen] = (0, _react.useState)(modalContent.modalOpen ?? false);
  const {
    isMobile
  } = (0, _patternLibraryUtils.useDeviceDetect)();
  const {
    height,
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const screenSettings = {
    height,
    width,
    isMobile
  };
  const [slidersData, setSlidersData] = (0, _react.useState)({});
  const {
    ref,
    inView
  } = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true
  });
  (0, _react.useEffect)(() => {
    if (inView) {
      (0, _patternLibraryUtils.logImpression)(`${eid}.impression`);
    }
  }, [inView, eid]);
  const handleClick = ({
    sales,
    transactions,
    ratio
  }) => {
    setSlidersData({
      CalcGMVValue: sales,
      CalcMonthlyTxn: transactions,
      CalcOnlinePercent: ratio
    });
    setModalOpen(true);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_savingsCalculator.default, (0, _extends2.default)({}, savingsCalculatorContent, {
    screenSettings: screenSettings,
    clickHandler: handleClick,
    eid: modalContent?.eid
  })), /*#__PURE__*/_react.default.createElement(_leadGenFormModal.default, (0, _extends2.default)({}, modalContent, {
    hideButton: true,
    modalOpen: modalOpen,
    onClose: () => setModalOpen(false),
    pipedriveDataFields: slidersData
  })));
}
SavingsCalculator.propTypes = {
  eid: _propTypes.default.string,
  modalContent: _propTypes.default.object,
  graphContent: _propTypes.default.object,
  outputContent: _propTypes.default.object,
  defaultValues: _propTypes.default.object,
  slidersContent: _propTypes.default.object
};
var _default = exports.default = SavingsCalculator;